import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Button from '../../components/ui/Button';
import { FaLeaf, FaHandshake } from 'react-icons/fa';
import { fadeInUp, standardViewport, delayTransition, simpleTransition } from '../../utils/animation';
import './HomeCTA.scss';

// Imagine de fundal pentru CTA - eliminată, nefolosită
// const CTA_IMAGE = '/images/cta-background.jpg';

const HomeCTA = () => {
  const { t } = useTranslation('home');
  
  return (
    <section className="section cta" style={{ backgroundColor: '#204710', backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5))` }}>
      <div className="cta__overlay">
        {/* Elemente decorative */}
        <div className="cta__decoration cta__decoration--left">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 0.15, x: 0 }}
            transition={simpleTransition}
            viewport={standardViewport}
          >
            <FaLeaf className="cta__icon cta__icon--large" />
          </motion.div>
        </div>
        
        <div className="cta__decoration cta__decoration--right">
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 0.15, x: 0 }}
            transition={simpleTransition}
            viewport={standardViewport}
          >
            <FaHandshake className="cta__icon cta__icon--large" />
          </motion.div>
        </div>
      
        <div className="container">
          <motion.div
            className="cta__content"
            initial="hidden"
            whileInView="visible"
            viewport={standardViewport}
            variants={fadeInUp}
          >
            <div className="cta__heading">
              <motion.div
                className="cta__heading-icon"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={simpleTransition}
                viewport={standardViewport}
              >
                <FaHandshake />
              </motion.div>
              
              <motion.h2
                className="cta__title"
                initial="hidden"
                whileInView="visible"
                viewport={standardViewport}
                variants={fadeInUp}
                transition={delayTransition(0.2)}
              >
                {t('cta.title')}
              </motion.h2>
            </div>
            
            <motion.div 
              className="cta__divider"
              initial={{ width: 0 }}
              whileInView={{ width: '80px' }}
              transition={delayTransition(0.3)}
              viewport={standardViewport}
            />
            
            <motion.p
              className="cta__text"
              initial="hidden"
              whileInView="visible"
              viewport={standardViewport}
              variants={fadeInUp}
              transition={delayTransition(0.4)}
            >
              {t('cta.description')}
            </motion.p>
            
            <motion.div
              className="cta__button-container"
              initial="hidden"
              whileInView="visible"
              viewport={standardViewport}
              variants={fadeInUp}
              transition={delayTransition(0.6)}
            >
              <Button 
                to="/contact"
                type="primary"
                as="link"
                className="cta__button"
              >
                {t('cta.button')}
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HomeCTA;
